import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import ContactUsComponent from '../../components/contactFormWidget';
import './contact.scss';

function ContactPage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('titles.contact')}</title>
            </Helmet>
            <div className="contact-page-wrapper">
                <Container>
                    <div className="top-banner-wrapper">
                        <h1
                            className="banner-header"
                            dangerouslySetInnerHTML={{
                                __html: t('contact-page.contact-title')
                            }}
                        />
                        <h2 className="banner-sub-header">{t('contact-page.contact-text')}</h2>
                    </div>
                    <ContactUsComponent />
                </Container>
                <div className="contact-bottom-text p-5">
                    <span className="contact-text">
                        {t('contact-page.contact-bottom-text')}{' '}
                        <u>
                            <i>abuse@obambu.com</i>
                        </u>
                    </span>
                </div>
            </div>
        </>
    );
}

export default ContactPage;
